import { CommonDateModeEnum, DatePreset, EndDateModeEnum } from './date-component.models';

export const defaultEndDatePreset = {
    mode: EndDateModeEnum.endOfYear,
    value: 'yyyy-12-31'
};
export const endDateModePresets: DatePreset[] = [
    {
        mode: EndDateModeEnum.endOfYear,
        label: 'End of year (yyyy-12-31)',
        value: 'yyyy-12-31'
    },
    {
        mode: EndDateModeEnum.oneYear,
        label: 'One year (D+365)',
        value: 'D+365'
    },
    {
        mode: CommonDateModeEnum.calendarDate,
        label: 'Fixed date',
        value: null
    },
    {
        mode: CommonDateModeEnum.custom,
        label: 'Advanced',
        value: null
    }
];
